import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { fadeIn, fadeInOut } from 'src/app/animations';
import { HealthService } from 'src/app/pages/privado/services/saude/health.service';
@Component({
  selector: 'app-modal-aviso-adesao',
  templateUrl: './modal-aviso-adesao.component.html',
  styleUrls: ['./modal-aviso-adesao.component.css'],
  animations: [fadeIn, fadeInOut]
})
export class ModalAvisoAdesaoComponent {
  @Output() passEntry: EventEmitter<any> = new EventEmitter();
  formData = this.formBuilder.group({
    aceite: new FormControl('', [Validators.required]),
  });
  constructor(public activeModal: NgbActiveModal, private formBuilder: FormBuilder, private healthService: HealthService) { }
  downloadTermo() {
    this.healthService.getTermoLgpdPdf().subscribe({
      next:
        (data: Blob) => {
          const a = document.createElement('a');
          a.setAttribute('style', 'display:none;');
          document.body.appendChild(a);
          a.download = "Termo de consentimento menores 12 anos LGPD.pdf";
          a.href = URL.createObjectURL(data);
          a.target = '_blank';
          a.click();
          document.body.removeChild(a);
        }
    })
  }
  closeModal() {
    this.passEntry.emit(this.formData.value.aceite);
    this.activeModal.dismiss(null);
  }
}
